import { render, staticRenderFns } from "./editUsdt.vue?vue&type=template&id=25fb3e54&scoped=true&"
import script from "./editUsdt.vue?vue&type=script&lang=js&"
export * from "./editUsdt.vue?vue&type=script&lang=js&"
import style0 from "./editUsdt.vue?vue&type=style&index=0&id=25fb3e54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fb3e54",
  null
  
)

export default component.exports